import React, { useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import { useNavigate } from "react-router-dom";
import InsuranceCard from "../Components/InsuranceCard";
import ReactPlayer from "react-player";
import axios from "axios";
import { BASE_URL } from "../Components/Api/Api";
import { useSelector } from "react-redux";
import CustomModal from "../Components/CustomModal";
import { fetchData } from "../../Cpanel/Components/Utilities";

const InsuranceTemplate = () => {
  const navigate = useNavigate();
  const authState = useSelector((state) => state.auth);
  console.log(authState)
  const cardData = [
    { iconName: "fa-solid fa-ruler-combined", name: "تامین آتیه فرزندان" },
    { iconName: "fa-solid fa-building", name: "حقوق دوران بازنشستگی" },
    {
      iconName: "fa-solid fa-lines-leaning",
      name: "اخذ وام بدون نیاز به تضامین",
    },
    {
      iconName: "fa-solid fa-money-check-dollar",
      name: "هزینه های درمان بیماری های خاص",
    },
    {
      iconName: "fa-solid fa-umbrella-beach",
      name: "سرمایه دوران از کار افتادگی",
    },
    { iconName: "fa-solid fa-tablet-screen-button", name: "سرمایه فوت" },
  ];
  const [video, setVideo] = useState([]);
  useEffect(() => {
    const bodyFormData = new FormData();
    bodyFormData.append("catid", 1);
    fetchData("getvideo", bodyFormData, handleApiResponse);
  }, []);
  const handleApiResponse = (data) => {
    const thirdvideos = data?.dt?.filter((video) => video.position === 0)[0];
    setVideo(thirdvideos);
  };
 

  function formatTime(seconds) {
    var minutes = Math.floor(seconds / 60);
    var remainingSeconds = seconds % 60;

    // Add leading zero if less than 10
    var formattedMinutes = minutes < 10 ? "0" + minutes : minutes;
    var formattedSeconds =
      remainingSeconds < 10 ? "0" + remainingSeconds : remainingSeconds;
    return formattedMinutes + ":" + formattedSeconds;
  }
  const [isModalOpen, setIsModalOpen] = useState(false);

  const closeModal = () => {
    setIsModalOpen(false);
  };

  function handleInsuranceRequest() {
    if (!authState?.isLoggedIn) {
      setIsModalOpen(true);
    } else {
      navigate("/LifeInsurance/insurancepayment");
    }
  }
  function handleBuyInsurance() {
    if (!authState?.isLoggedIn) {
      setIsModalOpen(true);
    } else {
      navigate("/LifeInsurance/insurancesteps");
    }
  }

  const handleExitModal = (value) => {
    // console.log("is exited", authState?.isLoggedIn);
    // setIsModalOpen(false);
    // if (value) {
    //   navigate("/LifeInsurance/insurancepayment");
    // }
    if (!authState?.isLoggedIn) {
      setIsModalOpen(true);
    } else {
      navigate("/LifeInsurance/insurancepayment");
    }
  };
  return (
    <div className="container ">
    
        <CustomModal
          onLogin={handleExitModal}
          isOpen={isModalOpen}
          closeModal={closeModal}
        />
      <h2 className="">بیمه عمر</h2>
      <br />
      <div className="d-flex justify-content-center align-items-center">
        <div className="row ">
          <div className="col-12 col-lg-6 m-auto">
            <div className="m-auto  text-center main-video">
              <ReactPlayer
                width={"100%"}
                height={"100%"}
                // class={'m-auto'}
                url={`https://api.taab30.com${video?.url}`}
                controls
              />
            </div>
            {/* <div className="d-flex flex-row justify-content-around  align-items-center">
              <div>
                <h4>{video?.title} </h4>
              </div>
              <div>{formatTime(video?.duration)}</div>
            </div> */}
          </div>
        </div>
      </div>
      <div className="d-flex justify-content-center m-4">
        <Button
          className={"btn btn-success btn-lg"}
          onClick={() => handleInsuranceRequest()}
        >
          درخواست صدور بیمه نامه
        </Button>
      </div>
      {/* <div className="d-flex justify-content-center m-4">
        <Button
          className={"btn btn-success btn-lg"}
          onClick={() => handleBuyInsurance()}
        >
          تکمیل بیمه نامه
        </Button>
      </div> */}
      <div className="my-5">
        <div className="insurance-title py-3 ">
          <h2>چرا در موعود بیمه عمر را محور اصلی خدمات رسانی قرار دادیم؟</h2>
        </div>
        <div className="insurance-body">
          <p>
            {" "}
            ما در مجموعه تاب سی به دنبال ایده ها و خدماتی هستیم که بتوانیم ریسک
            های زندگی هموطنانمان را کاهش داده، رفاه و امنیت زندگیشان را افزایش
            دهیم و از این طریق پیام آور امید به زندگی و آینده ای بهتر باشیم.
            بیمه عمر به عنوان بیمه ای که با هدف کاهش ریسک های زندگی در سرمایه
            گذاری در بلند مدت طراحی شده است یکی از راه‌های تامین و حفظ آتیه مالی
            خانواده و فرد، است. بیمه عمر که امروزه در سراسر جهان طرفداران زیادی
            دارد، در انواع مختلف و با پوشش‌های متنوع ارائه می‌شود تا در شرایط
            مختلف اعم از وقوع حوادث سرپرست خانواده، بازنشستگی، بیماری و …
            پشتوانه مالی مناسبی برای تمام اعضای خانواده فراهم کند. با بررسی هایی
            که صورت گرفت مشاهده کردیم که اکثر بیمه های عمر به دلیل عدم توانایی
            یا رغبت بیمه شده پایدار نیستند و پس از مدتی با بازخرید شده و یا رها
            می شوند .
          </p>
        </div>
      </div>
      <div className="">
        <p className="fs-3 py-3">چرا باید بیمه عمر داشته باشیم؟</p>
        <div>
          <div>
            <div className="row">
              {/*<img className={'cursor-pointer insurance-img'} src={InsuranceImage} alt={'why we should buy' +*/}
              {/*    ' insurance'}/>*/}
              {cardData.map((card, index) => (
                <InsuranceCard
                  key={index}
                  iconName={card.iconName}
                  name={card.name}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InsuranceTemplate;
